import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MOVE_ACTION_STEP, WebpathActionType } from 'src/app/shared/models';
import { ConflictData } from 'src/app/shared/models/move.model';
import { DirPickerService } from 'src/app/shared/services/dir-picker.service';

@Component({
  selector: 'app-move-conflicts',
  templateUrl: './move-conflicts.component.html',
  styleUrls: ['./move-conflicts.component.scss']
})
export class MoveConflictsComponent implements OnInit, OnChanges {
  @Input() conflictData: ConflictData;
  @Input() public actionStep: MOVE_ACTION_STEP = MOVE_ACTION_STEP.SELECT_DESTINATION_FOLDER;
  @Input() public conflictFileName: string = '';
  @Input() public conflictTotalCount: number = 0;
  @Input() public applyFixForTotalItemCount: number = 0;
  @Input() applyConflictForAll: boolean = false;
  @Input() actionMoveOrCopy: WebpathActionType = WebpathActionType.MOVE;
  webpathActionType: typeof WebpathActionType = WebpathActionType;

  @Output() applyConflictForAllChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public moveActionStep: typeof MOVE_ACTION_STEP = MOVE_ACTION_STEP;
  public destinationName = '';
  public checkboxLabel: string = '';
  constructor(public dirPickerService: DirPickerService,
  ) { }
  ngOnInit() {
    this.getDestination();
    this.checkboxLabel = `Apply to all ${this.applyFixForTotalItemCount} items`;
  }
  ngonchnage
  private getDestination() {
    this.destinationName = this.dirPickerService.getDestination();
  };
  ngOnChanges(): void {
    this.checkboxLabel = `Apply to all ${this.applyFixForTotalItemCount} items`;
  }
  checkboxChange = (checkboxChange: MatCheckboxChange): void => {
    this.applyConflictForAll = checkboxChange.checked;
    this.applyConflictForAllChange.emit(checkboxChange.checked)
  }
}
